import Phaser from "phaser";
import { GAME } from "./config";
import { InstallScene } from "./scenes/InstallScene";
import { MainMenuScene } from "./scenes/MainMenuScene";
import { LobbyScene } from "./scenes/LobbyScene";
import { SelectScene } from "./scenes/SelectScene";
import { FightScene } from "./scenes/FightScene";
import { FriendsScene } from "./scenes/FriendsScene";
import { SettingsScene } from "./scenes/SettingsScene";
import { LeaderboardScene } from "./scenes/LeaderboardScene";
import { TrainingScene } from "./scenes/TrainingScene";
import { MoveListScene } from "./scenes/MoveListScene";
import { armAutoFullscreenOnFirstTap } from "./ui/Fullscreen";
import { installDomScaleObserver } from "./ui/domScale";

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: "game",
  width: GAME.WIDTH,
  height: GAME.HEIGHT,
  backgroundColor: "#000000",
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  physics: {
    default: "arcade",
    arcade: { gravity: { x: 0, y: GAME.GRAVITY }, debug: false },
  },
  input: { gamepad: true },
  dom: { createContainer: true },     // нужно для login/password DOM input
  scene: [
    InstallScene, MainMenuScene, LobbyScene, SelectScene, FightScene,
    FriendsScene, SettingsScene, LeaderboardScene, TrainingScene, MoveListScene,
  ],
};

const game = new Phaser.Game(config);

armAutoFullscreenOnFirstTap();

if (typeof window !== "undefined" && (window as any).visualViewport) {
  const vv = (window as any).visualViewport as VisualViewport;
  const refresh = () => { try { game.scale.refresh(); } catch (_e) {} };
  vv.addEventListener("resize", refresh);
  vv.addEventListener("scroll", refresh);
  window.addEventListener("orientationchange", () => setTimeout(refresh, 200));
}

installDomScaleObserver(game);
